import { throttle } from 'lodash';
import { BaseController } from './BaseController';

export default class ArticleController extends BaseController {
  id = 'ArticleController';

  init() {
    this.root = this.getRoot();
    this.articleImage = this.singleChildNode('article-image');
    this.articleTeaserHeading = this.singleChildNode('article-teaser');
    this.articleProgress = this.singleChildNode('article-teaser-progress');
    this.articleColor = this.getData(this.articleTeaserHeading, 'articleColor');

    this.articleProgress.style.backgroundColor = this.articleColor;
    this.articleProgress.style.filter = "brightness(60%)";

    this.data = {
      limit: this.articleImage.offsetTop,
    };
    window.addEventListener('scroll', throttle(this.handleArticleScroll, 250));
    window.addEventListener('scroll', this.handleProgressbar);

    var params = new URLSearchParams(window.location.search);
    if (params.get('c')) {
      var postedComment = document.getElementById('c-' + params.get('c'));
      postedComment.classList.remove('hide-hidden-comment');
      params.delete('c');
    }
  }

  handleProgressbar = () => {
    this.articleProgress.style.width = (window.scrollY / (document.body.clientHeight - window.innerHeight)) * 100 + '%';
  };

  handleArticleScroll = () => {
    if (window.scrollY >= this.data.limit) {
      this.articleTeaserHeading.classList.add('article-teaser-show');
    } else {
      this.articleTeaserHeading.classList.remove('article-teaser-show');
    }
  };
}
